import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { CustomerDataSelector } from './CustomerDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { fecthCustomer } from './CustomerSlice';

export function useCustomer(): AbstractDataState<string, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fecthCustomer, CustomerDataSelector);
}
